import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Vendor, VendorEvaluation, VendorParams } from './types';

export const GET_VENDOR_LIST = 'vendors/GET_VENDOR_LIST';
export const GET_VENDOR_LIST_SUCCESS = 'vendors/GET_VENDOR_LIST_SUCCESS';
export const GET_VENDOR_LIST_ERROR = 'vendors/GET_VENDOR_LIST_ERROR';

export const UPDATE_VENDOR = 'vendors/UPDATE_VENDOR';
export const UPDATE_VENDOR_SUCCESS = 'vendors/UPDATE_VENDOR_SUCCESS';
export const UPDATE_VENDOR_ERROR = 'vendors/UPDATE_VENDOR_ERROR';

export const DELETE_VENDOR = 'vendors/DELETE_VENDOR';
export const DELETE_VENDOR_SUCCESS = 'vendors/DELETE_VENDOR_SUCCESS';
export const DELETE_VENDOR_ERROR = 'vendors/DELETE_VENDOR_ERROR';

export const GET_VENDOR_DETAIL = 'vendors/GET_VENDOR_DETAIL';
export const GET_VENDOR_DETAIL_SUCCESS = 'vendors/GET_VENDOR_DETAIL_SUCCESS';
export const GET_VENDOR_DETAIL_ERROR = 'vendors/GET_VENDOR_DETAIL_ERROR';

export const CREATE_VENDOR = 'vendors/CREATE_VENDOR';
export const CREATE_VENDOR_SUCCESS = 'vendors/CREATE_VENDOR_SUCCESS';
export const CREATE_VENDOR_ERROR = 'vendors/CREATE_VENDOR_ERROR';

export const CREATE_VENDOR_EVALUATION = 'vendors/CREATE_VENDOR_EVALUATION';
export const CREATE_VENDOR_EVALUATION_SUCCESS =
  'vendors/CREATE_VENDOR_EVALUATION_SUCCESS';
export const CREATE_VENDOR_EVALUATION_ERROR =
  'vendors/CREATE_VENDOR_EVALUATION_ERROR';

export const DELETE_VENDOR_EVALUATION = 'vendors/DELETE_VENDOR_EVALUATION';
export const DELETE_VENDOR_EVALUATION_SUCCESS =
  'vendors/DELETE_VENDOR_EVALUATION_SUCCESS';
export const DELETE_VENDOR_EVALUATION_ERROR =
  'vendors/DELETE_VENDOR_EVALUATION_ERROR';

export const getVendorListAsync = createAsyncAction(
  GET_VENDOR_LIST,
  GET_VENDOR_LIST_SUCCESS,
  GET_VENDOR_LIST_ERROR,
)<VendorParams, Vendor[], AxiosError>();

export const updateVendorAsync = createAsyncAction(
  UPDATE_VENDOR,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_ERROR,
)<VendorParams, Vendor, AxiosError>();

export const deleteVendorAsync = createAsyncAction(
  DELETE_VENDOR,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_ERROR,
)<VendorParams, any, AxiosError>();

export const getVendorDetailAsync = createAsyncAction(
  GET_VENDOR_DETAIL,
  GET_VENDOR_DETAIL_SUCCESS,
  GET_VENDOR_DETAIL_ERROR,
)<VendorParams, Vendor, AxiosError>();

export const createVendorAsync = createAsyncAction(
  CREATE_VENDOR,
  CREATE_VENDOR_SUCCESS,
  CREATE_VENDOR_ERROR,
)<VendorParams, Vendor, AxiosError>();

export const createVendorEvaluationAsync = createAsyncAction(
  CREATE_VENDOR_EVALUATION,
  CREATE_VENDOR_EVALUATION_SUCCESS,
  CREATE_VENDOR_EVALUATION_ERROR,
)<VendorParams, VendorEvaluation, AxiosError>();

export const deleteVendorEvaluationAsync = createAsyncAction(
  DELETE_VENDOR_EVALUATION,
  DELETE_VENDOR_EVALUATION_SUCCESS,
  DELETE_VENDOR_EVALUATION_ERROR,
)<VendorParams, any, AxiosError>();
